import { Component, Inject, Injectable, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ChartDefinition } from "./utils/dashboard/chartVariations";
import { generateChart } from "./utils/dashboard/chartComponentGenerator";
import { PageEvent } from "@angular/material/paginator";
import { analyticalMock } from "src/app/mockService/mockDataService";
import {
  getFormTemplate,
  getPageTemplate,
} from "./utils/createPage/fullFormSchema";
import { LayoutService } from "../../shared/components/main-nav/layoutservice";
import { chartNameeMap, getChartPreview } from "./utils/dashboard/chartutils";


@Component({
  selector: "app-chart-variant-dialog",
  standalone: false,
  styleUrls: ["./chart-variant-dialog.component.scss"],
  templateUrl: "./chart-variant-dialog.component.html",
})
@Injectable({
  providedIn: "root",
})
export class ChartVariantDialogComponent implements OnInit {
  myVariants: ChartDefinition[];
  private layoutService: LayoutService
  constructor(
    public dialogRef: MatDialogRef<ChartVariantDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { variants: ChartDefinition[]; model: string }
  ) {}
selectedTabIndex: number = 0; // default to first tab
  searchText: string = "";
  pageIndex: number = 0;
  pageSize: number = 12;
  chartTypes: string[] = [];
  selectedMeasures: string[] = [];
  selectedDimensions: string[] = [];
  allMeasures: string[] = [];
  allDimensions: string[] = [];
  variantCountMap: Record<string, number> = {};
  currentPageVariants:any[] = [];
pageIndexes: Record<string, number> = {};
selectedVariants: ChartDefinition[] = [];
  ngOnInit(): void {
    this.myVariants = this.data.variants;

    this.chartTypes = [...new Set(this.myVariants.map((v) => v.chartType))];
    this.chartTypes.forEach((type) => {
      this.variantCountMap[type] = this.myVariants.filter(
        (v) => v.chartType === type
      ).length;
    });

    this.allMeasures = Array.from(
      new Set(
        [].concat(
          ...this.myVariants.map((v) => v.measureField.map((m) => m.name))
        )
      )
    );

    this.allDimensions = Array.from(
      new Set(
        [].concat(
          ...this.myVariants.map((v) => v.dimensionField.map((d) => d.name))
        )
      )
    );

    // this.myVariants.forEach((v) => {
    //   v.selectedVariation = v.chartVariations?.[0]; // default to first
    //   // v.component =  [generateChart(v)];
    // });
    // this.myVariants.slice(0, this.pageSize).forEach((variant) => {
    //   // 1. Generate chart component
    //   variant.component = generateChart(variant, this.data.model);
    // });

    this.currentPageVariants = this.myVariants.slice(0, this.pageSize);
  }

  filteredVariantsByType(type: string): ChartDefinition[] {
    const filtered = this.myVariants.filter((variant) => {
      const isTypeMatch = variant.chartType === type;
      const isMeasureMatch =
        !this.selectedMeasures.length ||
        this.selectedMeasures.some((m) =>
          variant.measureField.some((f) => f.name === m)
        );
      const isDimensionMatch =
        !this.selectedDimensions.length ||
        this.selectedDimensions.some((d) =>
          variant.dimensionField.some((f) => f.name === d)
        );
      const isSearchMatch =
        !this.searchText ||
        variant.title.toLowerCase().includes(this.searchText.toLowerCase()) ||
        variant.shortTitle
          .toLowerCase()
          .includes(this.searchText.toLowerCase());
      return isTypeMatch && isMeasureMatch && isDimensionMatch && isSearchMatch;
    });

    const start = this.pageIndex * this.pageSize;
    const pageList = filtered.slice(start, start + this.pageSize);
    return pageList;
  }

  getFilteredCountByType(type: string): number {
    return this.myVariants.filter((variant) => {
      const isTypeMatch = variant.chartType === type;
      const isMeasureMatch =
        !this.selectedMeasures.length ||
        this.selectedMeasures.some((m) =>
          variant.measureField.some((f) => f.name === m)
        );
      const isDimensionMatch =
        !this.selectedDimensions.length ||
        this.selectedDimensions.some((d) =>
          variant.dimensionField.some((f) => f.name === d)
        );
      const isSearchMatch =
        !this.searchText ||
        variant.title.toLowerCase().includes(this.searchText.toLowerCase()) ||
        variant.shortTitle
          .toLowerCase()
          .includes(this.searchText.toLowerCase());
      return isTypeMatch && isMeasureMatch && isDimensionMatch && isSearchMatch;
    }).length;
  }
  get filteredVariants(): ChartDefinition[] {
    return this.myVariants.filter((variant) => {
      const matchMeasure =
        !this.selectedMeasures.length ||
        this.selectedMeasures.some((m) =>
          variant.measureField.some((f) => f.name === m)
        );

      const matchDimension =
        !this.selectedDimensions.length ||
        this.selectedDimensions.some((d) =>
          variant.dimensionField.some((f) => f.name === d)
        );

      const matchSearch =
        !this.searchText ||
        variant.title.toLowerCase().includes(this.searchText.toLowerCase()) ||
        variant.shortTitle
          .toLowerCase()
          .includes(this.searchText.toLowerCase());

      return matchMeasure && matchDimension && matchSearch;
    });
  }

  clearFilters() {
    this.searchText = "";
    this.selectedMeasures = [];
    this.selectedDimensions = [];
  }

  // selectVariant(variant: ChartDefinition) {
  //   //console.log("Selected chart variant:", variant);
  //   this.dialogRef.close(variant);
  // }
isSelected(variant: ChartDefinition): boolean {
  return this.selectedVariants.some(v => v.name === variant.name);
}
  onVariantSelect(variant: ChartDefinition) {
  const index = this.selectedVariants.findIndex(v => v.name === variant.name);

  if (index >= 0) {
    // Already selected → unselect
    this.selectedVariants.splice(index, 1);
  } else {
    // Not selected → add to selected
    this.selectedVariants.push(variant);
  }

  //console.log("Currently selected variants:", this.selectedVariants);

    // Optionally close dialog
    // this.dialogRef.close(variant);
  }



onTabChanged(index: number): void {
  this.currentPageVariants = undefined;
  const selectedType = this.chartTypes[index];
  this.pageIndex = 0; // Reset pagination to first page
  this.onPageChange({ pageIndex: 0, pageSize: this.pageSize } as PageEvent, selectedType);
}

onPageChange(event: PageEvent, type: string) {
  this.pageIndex = event.pageIndex;

 const currentPageVariants = this.filteredVariantsByType(type);
  // currentPageVariants.forEach((variant) => {
  //   if (!variant.component) {
  //     variant.component = generateChart(variant, this.data.model);
  //   }
  // });

this.currentPageVariants = currentPageVariants;
}

  getLayout(layout: any): Promise<any> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(layout);
      }, 300); // delay in milliseconds (e.g., 300ms)
    });
  }

  getChartName(name:string){
    return chartNameeMap[name];
  }

createDashboard(): void {
  this.dialogRef.close(this.selectedVariants);
}
}
